export default __webpack_public_path__ + "static/media/spin-a-win.b6cbe391.png";